module.exports = __webpack_public_path__ + "media/images/flags/as-b8b78e97a838db782715800cebd39f88.svg";